<template>
  <div style="margin-top: 40px">
    <div class="con_head">
      <div
        :class="['car', actives == 1 ? 'actives' : '']"
        @click="oncarShow(1)"
        style="border-radius: 6px 0 0 6px"
      >
        普通车牌
      </div>
      <div
        :class="['car', actives == 2 ? 'actives' : '']"
        @click="oncarShow(2)"
        style="border-radius: 0 6px 6px 0"
      >
        新能源车
      </div>
    </div>
    <div style="margin-top: 20px">
      <carNums
        :cartype="cartype"
        @child-event="handleChildData"
        :car="catnum"
      />
    </div>
    <div @click="onWhite" class="but">加入白名单</div>
    <div style="padding: 15px; margin-top: 30px">
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
        "
      ></div>
      <div>
        <div class="p_h_title">
          <div class="peak_title">
            <img
              class="peak_img"
              src="../../assets/dash/dash-icon8.png"
              alt=""
            />
            <div class="peak_text">白名单记录</div>
          </div>

          <van-search
            v-model="searchValue"
            show-action
            placeholder="请输入车牌号"
            @clear="onclear"
          >
            <template #action>
              <div @click="onSearch">搜索</div>
            </template>
          </van-search>
        </div>

        <div class="list">
          <div style="display: flex">
            <div class="list_head1">
              <div
                class="head_li"
                style="justify-content: flex-start; padding-left: 0.8rem"
              >
                车牌号
              </div>
              <div
                class="head_li"
                style="
                  text-align: right;
                  padding-right: 0.8rem;
                  width: 50px;
                  justify-content: flex-end;
                "
              >
                操作
              </div>
            </div>
            <div class="list_head1">
              <div
                class="head_li"
                style="justify-content: flex-start; padding-left: 0.8rem"
              >
                车牌号
              </div>
              <div
                class="head_li"
                style="
                  text-align: right;
                  padding-right: 0.8rem;
                  width: 50px;
                  justify-content: flex-end;
                "
              >
                操作
              </div>
            </div>
          </div>

          <div class="noList" v-if="whiteLists.length == 0">
            暂无长期白名单记录
          </div>
          <div v-if="whiteLists.length > 0">
            <div style="display: flex">
              <div style="width: 50%">
                <div
                  class="list_left"
                  v-for="(item, index) in leftColumn"
                  :key="index"
                  :style="{
                    backgroundColor:
                      index % 2 === 1 ? '#f3f9ff' : 'transparent',
                  }"
                >
                  <div
                    class="head_li_c"
                    style="justify-content: flex-start; padding-left: 0.8rem"
                  >
                    {{ item.plateNumber }}
                  </div>
                  <div
                    class="head_li_c"
                    style="
                      color: #ff3a3d;
                      justify-content: flex-end;
                      padding-right: 0.8rem;
                      width: 50px;
                    "
                    @click="ondel(item.id)"
                  >
                    删除
                  </div>
                </div>
              </div>

              <div style="width: 50%">
                <div
                  class="list_left"
                  v-for="(item, index) in rightColumn"
                  :key="index"
                  :style="{
                    backgroundColor:
                      index % 2 === 1 ? '#f3f9ff' : 'transparent',
                  }"
                >
                  <div
                    class="head_li_c"
                    style="justify-content: flex-start; padding-left: 0.8rem"
                  >
                    {{ item.plateNumber }}
                  </div>
                  <div
                    class="head_li_c"
                    style="
                      color: #ff3a3d;
                      justify-content: flex-end;
                      padding-right: 0.8rem;
                      width: 50px;
                    "
                    @click="ondel(item.id)"
                  >
                    删除
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <div class="bot_title">版权所有：陕西关山草原旅游发展有限责任公司</div>
  </div>
</template>
<script>
import request from "@/api/index";
import carNums from "../../components/carNums.vue";
import { Toast, Dialog } from "vant";

export default {
  // name: 'Home',
  components: {
    carNums,
  },
  data() {
    return {
      actives: 1,
      cartype: 1,
      catnum: "", //传递的车牌
      parentData: "",
      whiteLists: [], //白名单列表
      openId: "",
      // value: 2, //白名单默认时间
      searchValue: "",
    };
  },
  computed: {
    leftColumn() {
      return this.whiteLists.filter((_, index) => index % 2 === 0);
    },
    rightColumn() {
      return this.whiteLists.filter((_, index) => index % 2 === 1);
    },
  },
  mounted() {
    const opens = localStorage.getItem("openid");
    if (opens) {
      this.openId = opens;
      this.getWhite();
    }
  },
  methods: {
    //切换车牌类型
    oncarShow(index) {
      this.actives = index;
      this.cartype = index;
    },
    //加入长期白名单
    async onWhite() {
      if (!this.parentData) {
        Toast("请输入车牌");
        return;
      }
      if (this.parentData.length < 7) {
        Toast("请输入完整车牌");
        return;
      }
      const num = {
        plateNumber: this.parentData,
      };
      const open = this.openId;
      const res = await request.addLongWhite(num, open);
      if (res.status == 200) {
        if (res.data.code == 400) {
          Toast(res.data.message);
          return;
        }
        this.parentData = "";
        this.catnum=this.cartype
        this.getWhite();
        Toast("添加成功");
      }
    },
    //查询长期白名单列表
    async getWhite() {
      const nums = {
        openId: this.openId,
        plateNumber: this.searchValue,
      };
      const res = await request.whiteListLong(nums);
      console.log(res);

      if (res.status == 200) {
        if (res.data.code == 403) {
          Toast(res.data.message);
          return;
        }
        this.whiteLists = res.data.data;
      }
    },
    // 接收子组件的数据
    handleChildData(data) {
      this.parentData = data;
    },
    //删除记录
    async ondel(id) {
      Dialog.confirm({
        // title: '标题',
        message: "确定要删除此条白名单吗？",
      })
        .then(async () => {
          // on confirm
          const open = this.openId;
          const res = await request.deleteLongwhiteList(id, open);
          if (res.data.data == 1) {
            Toast("删除成功");
            this.getWhite();
          }
        })
        .catch(() => {
          // on cancel
        });
    },
    onSearch() {
      console.log(this.searchValue);
      this.getWhite();
    },
    onclear() {
      this.searchValue = "";
      this.getWhite();
    },
  },
};
</script>
<style scoped>
@import "longTerm.css";
</style>